import { ModalProvider } from "@/contexts";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { ThemeProvider } from "@emotion/react";
import router from "@router/router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import GlobalStyles from "@theme/global";
import theme from "@theme/theme";
import { useState } from "react";
import { HelmetProvider } from "react-helmet-async";
import { RouterProvider } from "react-router-dom";
import { RecoilRoot } from "recoil";

const App = () => {
    const [queryClient] = useState(() => new QueryClient());
    const chakraTheme = extendTheme(theme);

    return (
        <QueryClientProvider client={queryClient}>
            <RecoilRoot>
                <ChakraProvider theme={chakraTheme}>
                    <ModalProvider>
                        <ThemeProvider theme={theme}>
                            <GlobalStyles />
                            <HelmetProvider>
                                <RouterProvider router={router} />
                            </HelmetProvider>
                        </ThemeProvider>
                    </ModalProvider>
                </ChakraProvider>
            </RecoilRoot>
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
};

export default App;
